export default __webpack_public_path__ + "static/media/meter-locked.d86a97a1.svg";